<template>
    <div class="detail-right-sidebar">

        <div class="price">

            Reserva por
            <span class="number">7€</span>
            Por Hora

            <div class="clear mb-10"></div>
            <div class="or-text"><span><span>o modifica tu reserva</span></span></div>

        </div>

        <div class="detail-search-form">
            <div class="inner">
                <form class="gap-10">
                    <div class="col-xs-12 col-sm-12">
                        <div class="form-group form-icon-right mb-10">
                            <font-awesome-icon style="margin-right: 0.5em;" icon="calendar"/>
                            <label>Check-in </label>
                            <input name="arrival_date" v-model="checkin" class="form-control mb-0" id="dpd1"
                                   placeholder="Check-in" type="date">
                            <input type="time" v-model="inhour" class="form-control mb-0 time"
                                   name="usr_time">
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12">
                        <div class="form-group form-icon-right mb-10">
                            <font-awesome-icon style="margin-right: 0.5em;" icon="calendar"/>
                            <label>Check-out </label>
                            <<input name="departure_date" class="form-control mb-0" id="dpd2" v-model="checkoutval" placeholder="Check-out"
                                    type="date">
                            <input type="time" id="outhour" class="form-control mb-0 time"
                                   name="usr_time">

                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12">
                        <div class="form-group">
                            <font-awesome-icon style="margin-right: 0.5em;" icon="users"/>
                            <label>Personas</label>
                            <input type="number" class="form-control mb-0" placeholder="0">
                        </div>
                    </div>
                    <div class="clear"></div>

                    <div class="col-sm-12">
                        <button class="btn btn-block  btn-icon mt-5">Buscar <span class="icon">
                            <font-awesome-icon icon="search"/>
</span></button>
                    </div>

                    <div class="clear mb-10"></div>

                    <div class="clear"></div>

                </form>
            </div>

        </div>

        <div class="detail-subtotal-price">
            <h4 class="uppercase">Subtotal <a href="#">reset</a></h4>
            <div class="content">
                <p class="price-subtotal mb-10"><span class="font600">7€</span> - 1 hora</p>
                <router-link to="/billing">
                    <button class="btn btn-block btn-icon ">Reserva ahora <span class="icon"><font-awesome-icon
                            icon="shopping-cart"/></span></button>
                </router-link>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "rightForm",
        data: function () {
            return {
                checkin: '',
                checkoutval:'',
                inhour: ''
            }
        },
        watch: {
            'checkin': function () {
                this.setmincheckout(this.checkin);
            },
            'inhour': function () {
                this.setminhour(this.inhour);
            }
        },
        mounted() {
            this.setmincheckin();
            this.setmincheckout()
        },
        methods: {
            setmincheckin() {
                console.log(this.$route.params.checkin);
                let today;
                if (this.$route.params.checkin === undefined) {
                    today = new Date();
                    let dd = today.getDate();
                    let mm = today.getMonth() + 1; //January is 0!
                    let yyyy = today.getFullYear();
                    if (dd < 10) {
                        dd = '0' + dd
                    }
                    if (mm < 10) {
                        mm = '0' + mm
                    }
                    today = yyyy + '-' + mm + '-' + dd;
                } else today = this.$route.params.checkin;
                this.checkin = today;
                this.checkoutval = today;
                document.getElementById("dpd1").min = today;
            },
            setmincheckout(date) {
                let datday;
                if (date === undefined) {
                    let today = new Date();
                    let dd = today.getDate();
                    let mm = today.getMonth() + 1; //January is 0!
                    let yyyy = today.getFullYear();
                    if (dd < 10) {
                        dd = '0' + dd
                    }
                    if (mm < 10) {
                        mm = '0' + mm
                    }
                    datday = yyyy + '-' + mm + '-' + dd;
                }
                datday = date;
                document.getElementById("dpd2").min = datday;
            },
            setminhour(hour) {
                document.getElementById("outhour").value = hour;
            }
        }
    }
</script>

<style scoped>
    .btn-icon {
        background: #8ac6c4 !important;
    }

    .btn-icon:hover {
        color: #FFF !important;
    }

    .time {
        margin-top: 1em;
    }
</style>